import React from 'react';
import { nodeTemplates } from './utils/nodeTemplates';
import './NodePalette.css';

function NodePalette() {
  const onDragStart = (event, nodeType, nodeData) => {
    event.dataTransfer.setData('application/reactflow-type', nodeType);
    event.dataTransfer.setData('application/reactflow-data', JSON.stringify(nodeData));
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="node-palette">
      <div className="palette-header">
        <h3>Node Palette</h3>
        <p>Drag nodes to canvas</p>
      </div>
      
      <div className="palette-section">
        <h4>Execution Nodes</h4>
        
        {/* LLM Node */}
        <div
          className="palette-node llm"
          draggable
          onDragStart={(e) => onDragStart(e, 'llmNode', nodeTemplates.llmNode)}
        >
          <div className="palette-node-icon">🤖</div>
          <div className="palette-node-info">
            <span className="palette-node-name">LLM Node</span>
            <span className="palette-node-desc">LLM-based processing</span>
          </div>
        </div>

        {/* Platform Pipeline Node */}
        <div
          className="palette-node snn"
          draggable
          onDragStart={(e) => onDragStart(e, 'snnPipelineNode', nodeTemplates.snnPipelineNode)}
        >
          <div className="palette-node-icon">🧠</div>
          <div className="palette-node-info">
            <span className="palette-node-name">Platform Pipeline</span>
            <span className="palette-node-desc">Knowledge graph query</span>
          </div>
        </div>

        {/* HTTP Node */}
        <div
          className="palette-node http"
          draggable
          onDragStart={(e) => onDragStart(e, 'httpNode', nodeTemplates.httpNode)}
        >
          <div className="palette-node-icon">🌐</div>
          <div className="palette-node-info">
            <span className="palette-node-name">HTTP Node</span>
            <span className="palette-node-desc">External API calls</span>
          </div>
        </div>

        {/* Python Node */}
        <div
          className="palette-node python"
          draggable
          onDragStart={(e) => onDragStart(e, 'pythonNode', nodeTemplates.pythonNode)}
        >
          <div className="palette-node-icon">🐍</div>
          <div className="palette-node-info">
            <span className="palette-node-name">Python Node</span>
            <span className="palette-node-desc">Custom code + MCP calls</span>
          </div>
        </div>

        {/* Cross-Link Node */}
        <div
          className="palette-node cross-link"
          draggable
          onDragStart={(e) => onDragStart(e, 'crossLinkNode', nodeTemplates.crossLinkNode)}
        >
          <div className="palette-node-icon">🔗</div>
          <div className="palette-node-info">
            <span className="palette-node-name">Cross-Link</span>
            <span className="palette-node-desc">Invoke another process / graph</span>
          </div>
        </div>
      </div>

      <div className="palette-section">
        <h4>Categorical Reasoning</h4>

        {/* Case Evidence Extractor */}
        <div
          className="palette-node case-extractor"
          draggable
          onDragStart={(e) => onDragStart(e, 'caseExtractorNode', nodeTemplates.caseExtractorNode)}
        >
          <div className="palette-node-icon">📑</div>
          <div className="palette-node-info">
            <span className="palette-node-name">Case Extractor</span>
            <span className="palette-node-desc">Raw text → CaseEvidenceFrame</span>
          </div>
        </div>

        {/* Categorical Chain Reasoner */}
        <div
          className="palette-node chain-reasoner"
          draggable
          onDragStart={(e) => onDragStart(e, 'chainReasonerNode', nodeTemplates.chainReasonerNode)}
        >
          <div className="palette-node-icon">⛓️</div>
          <div className="palette-node-info">
            <span className="palette-node-name">Chain Reasoner</span>
            <span className="palette-node-desc">Multi-pack violations report</span>
          </div>
        </div>
      </div>

      <div className="palette-section">
        <h4>Flow Control</h4>
        
        {/* AND Gate */}
        <div
          className="palette-node gate-and"
          draggable
          onDragStart={(e) => onDragStart(e, 'gateNode', { 
            ...nodeTemplates.gateNode, 
            gate_type: 'AND',
            name: 'AND Gate',
            description: 'Fires when ALL inputs complete'
          })}
        >
          <div className="palette-node-icon">◆</div>
          <div className="palette-node-info">
            <span className="palette-node-name">AND Gate</span>
            <span className="palette-node-desc">All inputs required</span>
          </div>
        </div>

        {/* OR Gate */}
        <div
          className="palette-node gate-or"
          draggable
          onDragStart={(e) => onDragStart(e, 'gateNode', {
            ...nodeTemplates.gateNode,
            gate_type: 'OR',
            name: 'OR Gate',
            description: 'Fires when ANY input completes'
          })}
        >
          <div className="palette-node-icon">◇</div>
          <div className="palette-node-info">
            <span className="palette-node-name">OR Gate</span>
            <span className="palette-node-desc">Any input triggers</span>
          </div>
        </div>

        {/* THRESHOLD Gate */}
        <div
          className="palette-node gate-threshold"
          draggable
          onDragStart={(e) => onDragStart(e, 'gateNode', {
            ...nodeTemplates.gateNode,
            gate_type: 'THRESHOLD',
            name: 'Threshold Gate',
            description: 'Fires when N of M inputs complete',
            threshold: 2
          })}
        >
          <div className="palette-node-icon">⬡</div>
          <div className="palette-node-info">
            <span className="palette-node-name">Threshold Gate</span>
            <span className="palette-node-desc">N of M inputs</span>
          </div>
        </div>
      </div>

      <div className="palette-footer">
        <p>Tip: Connect nodes by dragging from output handle to input handle</p>
      </div>
    </div>
  );
}

export default NodePalette;
